import { Checkbox } from 'antd';
import AntCheckbox from './styles/checkbox.style';

const checkbox = AntCheckbox(Checkbox);

export default checkbox;


// WEBPACK FOOTER //
// ./src/components/UI/Checkbox.js